module.exports = __webpack_public_path__ + "img/open-table-rate-right-bottom-icon.155646cc.png";